import { render, staticRenderFns } from "./NewCardTecs.vue?vue&type=template&id=95512b12&scoped=true&"
import script from "./NewCardTecs.vue?vue&type=script&lang=js&"
export * from "./NewCardTecs.vue?vue&type=script&lang=js&"
import style0 from "./NewCardTecs.vue?vue&type=style&index=0&id=95512b12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95512b12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
